import { jsx } from "react/jsx-runtime";
import { Box } from "@zillow/constellation";
import { forwardRef } from "react";
const OverlappingStack = forwardRef(function OverlappingStack2(props, ref) {
  return /* @__PURE__ */ jsx(Box, { ...props, ref, sx: {
    ...props.sx,
    display: "grid",
    "> *": {
      gridArea: "1 / 1"
    }
  } });
});
export {
  OverlappingStack as default
};
